export const API_ENDPOINTS =
    {
        "GET_OFFLINE_MODE": "offline-status",
        "GET_RFC_BY_ID": "approvals/rfc/get-rfc-by-id/?rfcId=",
        "UPDATE_RFC": "update-rfc",
        "VENDOR_UPDATE_RFC": "approvals/rfc/update-rfc"
    };



// WEBPACK FOOTER //
// ./src/providers/api/api.constants.ts